/**
 * Menu Dropdown Section Loader
 * This script handles loading dynamic sections into dropdown menus
 */

class MenuDropdownSections {
  constructor() {
    this.init();
  }

  init() {
    // Initialize dropdowns
    const dropdownToggles = document.querySelectorAll('.menu-dropdown-toggle');

    dropdownToggles.forEach((toggle) => {
      toggle.addEventListener('click', this.toggleDropdown.bind(this));
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const toggle = event.currentTarget;
    const dropdown = toggle.nextElementSibling;
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    // Toggle dropdown visibility
    toggle.setAttribute('aria-expanded', !isExpanded);
    dropdown.classList.toggle('hidden', isExpanded);

    // Load section content if needed
    if (!isExpanded) {
      const dynamicSection = dropdown.querySelector('.dynamic-section');

      if (dynamicSection && !dynamicSection.hasAttribute('data-loaded')) {
        this.loadSectionContent(dynamicSection);
      }
    }
  }

  handleOutsideClick(event) {
    const openDropdowns = document.querySelectorAll(
      '.menu-dropdown-toggle[aria-expanded="true"]',
    );

    openDropdowns.forEach((toggle) => {
      const dropdown = toggle.nextElementSibling;

      if (!toggle.contains(event.target) && !dropdown.contains(event.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.classList.add('hidden');
      }
    });
  }

  loadSectionContent(container) {
    const sectionId = container.getAttribute('data-section-id');

    if (!sectionId) return;

    // Fetch the section content
    fetch(`/?sections=${sectionId}`)
      .then((response) => response.json())
      .then((data) => {
        if (data[sectionId]) {
          container.innerHTML = data[sectionId];
          container.setAttribute('data-loaded', 'true');

          // Initialize any scripts needed for the section
          this.initializeSectionScripts(container);
        }
      })
      .catch((error) => {
        console.error('Error loading section content:', error);
      });
  }

  initializeSectionScripts(container) {
    // This method can be extended to initialize specific functionality
    // for sections that may require JavaScript to work properly

    // Example: reinitialize sliders, product forms, etc.
    if (window.Shopify && window.Shopify.designMode) {
      if (window.Shopify.designMode.evalScripts) {
        window.Shopify.designMode.evalScripts(container);
      }
    }
  }
}

// Initialize the menu dropdown system when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new MenuDropdownSections();
});
